// frontend/src/components/automation/ProgressBar.jsx
import React from 'react'
import { motion } from 'framer-motion'

const ProgressBar = ({ current = 0, total = 0, className = '' }) => {
  const percentage = total > 0 ? (current / total) * 100 : 0
  
  return (
    <div className={`w-full bg-gray-200 rounded-full h-2 overflow-hidden ${className}`}>
      <motion.div
        className="h-full bg-primary-600 rounded-full"
        initial={{ width: 0 }}
        animate={{ width: `${percentage}%` }}
        transition={{ duration: 0.3 }}
      />
    </div>
  )
}

export default ProgressBar